(() => {
  'use strict';
  const configElement = document.getElementById('WellogicLocalizationConfig');
  if (!configElement) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch (_) { return; }
  const current = config.language;
  const languages = Array.isArray(config.languages) ? config.languages : [];
  const preferenceKey = 'wellogic_language_preference_v1';
  const visitKey = 'wellogic_language_visit_v1';
  const attemptKey = 'wellogic_language_attempt_v1';
  const manualForm = document.getElementById('WellogicLanguageForm');
  const autoForm = document.getElementById('WellogicAutoLanguageForm');
  const dropdown = document.querySelector('[data-wl-language]');
  let manualSelection = false;
  let controller;

  function read(key, persistent = false) {
    try {
      const storage = persistent ? localStorage : sessionStorage;
      const value = JSON.parse(storage.getItem(key));
      if (value && value.expires > Date.now()) return value.value;
    } catch (_) { /* Cookie fallback also works when web storage is unavailable. */ }
    try {
      const entry = document.cookie.split('; ').find(part => part.startsWith(key + '='));
      return entry ? JSON.parse(decodeURIComponent(entry.slice(key.length + 1))) : null;
    } catch (_) { return null; }
  }

  function write(key, value, seconds, persistent = false) {
    let saved = false;
    try {
      (persistent ? localStorage : sessionStorage).setItem(key, JSON.stringify({value, expires: Date.now() + seconds * 1000}));
      saved = true;
    } catch (_) { /* Use first-party preference cookies as a fallback. */ }
    try {
      document.cookie = key + '=' + encodeURIComponent(JSON.stringify(value)) + '; Path=/; Max-Age=' + seconds + '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
      saved = saved || document.cookie.split('; ').some(part => part.startsWith(key + '='));
    } catch (_) { /* Manual forms still work when all storage is blocked. */ }
    return saved;
  }

  // This PDP pairs its English and Spanish experiences with their selling markets.
  function pairedCountry(language) {
    if (!config.pairedProductMarket) return null;
    return language.split('-')[0] === 'es' ? 'MX' : language.split('-')[0] === 'en' ? 'US' : null;
  }
  function setCountry(form, country) {
    if (!form || !country) return;
    let input = form.querySelector('input[name="country_code"]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'country_code'; form.appendChild(input); }
    input.value = country;
  }
  function returnTo(form) {
    if (form) form.querySelectorAll('input[name="return_to"]').forEach(input => {
      const params = new URLSearchParams(location.search);
      if (config.pairedProductMarket) { params.delete('country'); params.delete('currency'); }
      input.value = location.pathname + (params.size ? '?' + params.toString() : '') + location.hash;
    });
  }

  if (manualForm) {
    returnTo(manualForm);
    manualForm.addEventListener('submit', event => {
      const language = event.submitter && event.submitter.value;
      if (!languages.includes(language)) { event.preventDefault(); return; }
      manualSelection = true;
      if (controller) controller.abort();
      returnTo(manualForm);
      write(preferenceKey, language, 180 * 24 * 60 * 60, true);
      write(visitKey, language, 30 * 60);
      const country = pairedCountry(language);
      setCountry(manualForm, country);
      if (language === current && (!country || country === config.country)) {
        event.preventDefault();
        if (dropdown) dropdown.open = false;
      }
    });
  }
  if (dropdown) {
    document.addEventListener('click', event => {
      if (!dropdown.contains(event.target)) dropdown.open = false;
    });
    dropdown.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        dropdown.open = false;
        dropdown.querySelector('summary').focus();
      }
    });
  }

  function supported(language) {
    if (typeof language !== 'string') return null;
    const exact = languages.find(value => value.toLowerCase() === language.toLowerCase());
    return exact || languages.find(value => value.split('-')[0] === language.toLowerCase().split('-')[0]) || null;
  }

  function isPreview() {
    const params = new URLSearchParams(location.search);
    return config.designMode || (window.Shopify && (Shopify.designMode || Shopify.visualPreviewMode)) || params.has('preview_theme_id') || params.has('preview_key') || !!document.querySelector('iframe[src*="shopifycloud/preview-bar/"]');
  }

  function changeLanguage(language) {
    const country = language && pairedCountry(language);
    if (!language || (language === current && (!country || country === config.country)) || !autoForm || manualSelection || isPreview()) return;
    // A failed localization request must never bounce a visitor in a redirect loop.
    const attempt = country ? language + ':' + country : language;
    if (read(attemptKey) === attempt || !write(attemptKey, attempt, 60)) return;
    returnTo(autoForm);
    autoForm.querySelector('input[name="language_code"]').value = language;
    setCountry(autoForm, country);
    autoForm.submit();
  }

  async function localize() {
    if (isPreview()) return;
    if (/bot|crawl|spider|slurp|bingpreview|Google-InspectionTool/i.test(navigator.userAgent)) return;
    if (config.pairedProductMarket) {
      write(preferenceKey, current, 180 * 24 * 60 * 60, true);
      write(visitKey, current, 30 * 60);
      changeLanguage(current);
      return;
    }
    const preference = supported(read(preferenceKey, true));
    if (preference) { changeLanguage(preference); return; }
    const visit = supported(read(visitKey));
    if (visit) { changeLanguage(visit); return; }

    let country = null;
    let suggestedLanguage = null;
    controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 2500);
    try {
      const root = config.root.replace(/\/$/, '') + '/';
      const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {credentials: 'same-origin', signal: controller.signal});
      if (response.ok) {
        const data = await response.json();
        country = data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        const suggestion = (data.suggestions || []).find(item => item.parts && item.parts.language);
        suggestedLanguage = suggestion && suggestion.parts.language.handle;
      }
    } catch (_) { /* Keep browsing usable when geolocation is slow or unavailable. */ }
    finally { clearTimeout(timeout); }
    if (manualSelection) return;
    const browserLanguage = (navigator.languages && navigator.languages[0]) || navigator.language;
    const target = (config.spanishCountries.includes(country) && supported('es')) || supported(suggestedLanguage) || supported(browserLanguage) || current;
    // Without storage, leave automatic navigation off rather than risk repeated redirects.
    if (write(visitKey, target, 30 * 60)) changeLanguage(target);
  }
  localize();
})();
